export const colorTypes = {
  GRAYSCALE: "grayscale",
  PRIMARY: "primary",
  SPECIAL: "special",
  ERROR: "error",
  WARRING: "warring",
};

export const colorHues = {
  25: "25",
  50: "50",
  100: "100",
  200: "200",
  300: "300",
  400: "400",
  500: "500",
  600: "600",
  700: "700",
  800: "800",
  900: "900",
};

export enum color {
  // Grayscale
  GRAYSCALE_25 = "#FCFCFD",
  GRAYSCALE_50 = "#F9FAFB",
  GRAYSCALE_100 = "#F2F4F7",
  GRAYSCALE_200 = "#EAECF0",
  GRAYSCALE_300 = "#D0D5DD",
  GRAYSCALE_400 = "#98A2B3",
  GRAYSCALE_500 = "#667085",
  GRAYSCALE_600 = "#475467",
  GRAYSCALE_700 = "#344054",
  GRAYSCALE_800 = "#1D2939",
  GRAYSCALE_900 = "#101828",

  // Primary
  PRIMARY_25 = "#EAF2FB",
  PRIMARY_50 = "#D6E5F8",
  PRIMARY_100 = "#C1D9F4",
  PRIMARY_200 = "#ADCCF1",
  PRIMARY_300 = "#83B2E9",
  PRIMARY_400 = "#5A99E2",
  PRIMARY_500 = "#317FDB",
  PRIMARY_600 = "#2766AF",
  PRIMARY_700 = "#1D4C83",
  PRIMARY_800 = "#143358",
  PRIMARY_900 = "#0F2642",

  // Special
  SPECIAL_25 = "#ECF6F4",
  SPECIAL_50 = "#D8EDEA",
  SPECIAL_100 = "#C5E5DF",
  SPECIAL_200 = "#B1DCD4",
  SPECIAL_300 = "#8BCABF",
  SPECIAL_400 = "#64B9A9",
  SPECIAL_500 = "#3DA794",
  SPECIAL_600 = "#318676",
  SPECIAL_700 = "#256459",
  SPECIAL_800 = "#18433B",
  SPECIAL_900 = "#12322C",

  // Error
  ERROR_25 = "#FFFBFA",
  ERROR_50 = "#FEF3F2",
  ERROR_100 = "#FEE4E2",
  ERROR_200 = "#FECDCA",
  ERROR_300 = "#FDA29B",
  ERROR_400 = "#F97066",
  ERROR_500 = "#F04438",
  ERROR_600 = "#D92D20",
  ERROR_700 = "#B42318",
  ERROR_800 = "#912018",
  ERROR_900 = "#7A271A",

  // Warring
  WARRING_25 = "#FFFCF5",
  WARRING_50 = "#FFFAEB",
  WARRING_100 = "#FEF0C7",
  WARRING_200 = "#FEDF89",
  WARRING_300 = "#FEC84B",
  WARRING_400 = "#FDB022",
  WARRING_500 = "#F79009",
  WARRING_600 = "#DC6803",
  WARRING_700 = "#B54708",
  WARRING_800 = "#93370D",
  WARRING_900 = "#7A2E0E",

  GOLD = "#FFB800",
  BLUE = "#3762FA",
  COUPON_BLUE = "#0C6FEA",
  GREEN = "#1CBA4F",
  DARK_ORANGE = "#FF6910",

  // Primitive
  BLACK = "#000000",
  WHITE = "#FFFFFF",

  TRANSPARENT_WHITE_80 = "rgba(255, 255, 255, 0.8)",
}

export const colors = Object.freeze({ ...color });
export type colorVariants = (typeof colors)[keyof typeof colors];
